(() => {
  const debounce = (fn, wait = 220) => { let timer; return (...args) => { clearTimeout(timer); timer = setTimeout(() => fn(...args), wait); }; };
  const money = (price) => {
    const amount = Number(String(price ?? 0).replace(/[^\d.-]/g, ''));
    const safeAmount = Number.isFinite(amount) ? amount : 0;
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-PK', { style: 'currency', currency: window.Shopify?.currency?.active || 'PKR', maximumFractionDigits: 0 }).format(safeAmount); }
    catch (_) { return `PKR ${Math.round(safeAmount).toLocaleString()}`; }
  };
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  const search = async (input, results) => {
    const term = input.value.trim();
    if (term.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
    results.hidden = false;
    results.innerHTML = '<div class="aib-search-status">Searching...</div>';
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product,collection,query&resources[limit]=8&resources[options][unavailable_products]=last`;
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Search unavailable');
      const data = await response.json();
      const products = data.resources?.results?.products || [];
      if (!products.length) {
        results.innerHTML = `<div class="aib-search-status">No exact match. Try a brand, category, fabric or a shorter phrase.<br><a href="/search?q=${encodeURIComponent(term)}">View full search</a></div>`;
        return;
      }
      results.innerHTML = products.map(product => `<a class="aib-search-result" href="${escapeHtml(product.url)}"><img src="${escapeHtml(product.image || '')}" alt="" loading="lazy"><span><b>${escapeHtml(product.title)}</b><small>${money(product.price)}</small></span></a>`).join('');
    } catch (_) {
      results.innerHTML = `<div class="aib-search-status"><a href="/search?q=${encodeURIComponent(term)}">Continue to search results</a></div>`;
    }
  };
  document.querySelectorAll('[data-aib-search-root]').forEach(root => {
    const input = root.querySelector('[data-aib-search-input]');
    const results = root.querySelector('[data-aib-search-results]');
    if (input && results) {
      input.addEventListener('focus', () => {
        if (input.value.trim()) return;
        results.hidden = false;
        results.innerHTML = '<div class="aib-search-status"><b>Popular searches</b><br><a href="/search?type=product&q=new+arrivals">New arrivals</a> &nbsp; <a href="/search?type=product&q=unstitched">Unstitched</a> &nbsp; <a href="/search?type=product&q=formal">Formal wear</a> &nbsp; <a href="/search?type=product&q=sale">Sale</a></div>';
      });
      input.addEventListener('input', debounce(() => search(input, results)));
    }
  });
  const mobile = document.querySelector('[data-aib-mobile-search]');
  if (mobile) {
    const input = mobile.querySelector('[data-aib-search-input]');
    const results = mobile.querySelector('[data-aib-search-results]');
    const popular = mobile.querySelector('[data-aib-popular]');
    const open = () => { mobile.hidden = false; document.documentElement.style.overflow = 'hidden'; setTimeout(() => input?.focus(), 50); };
    const close = () => { mobile.hidden = true; document.documentElement.style.overflow = ''; };
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-aib-search-open], [aria-controls="drawer-search-form"], .mobile-header-extras__search input, .hdt-search_form input[type="search"]');
      if (trigger && window.matchMedia('(max-width: 1149px)').matches) { event.preventDefault(); open(); }
    });
    mobile.querySelectorAll('[data-aib-search-close]').forEach(button => button.addEventListener('click', close));
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && !mobile.hidden) close(); });
    input?.addEventListener('input', debounce(() => { popular.hidden = input.value.trim().length >= 2; search(input, results); }));
  }
  const marketHeader = document.querySelector('[data-aib-market-header]');
  const marketDialog = document.querySelector('[data-aib-market-dialog]');
  const marketForm = marketDialog?.querySelector('[data-aib-market-form]');
  const marketCountry = marketForm?.querySelector('[data-aib-market-country]');
  const marketStatus = marketForm?.querySelector('[data-aib-market-status]');
  const marketSave = marketForm?.querySelector('[data-aib-market-save]');
  const marketFields = [...(marketForm?.querySelectorAll('[data-aib-market-field]') || [])];
  let countryOptionsByCode = new Map();
  let optionsByField = new Map();
  const indexMarketOptions = () => {
    const countryOptions = [...(marketForm?.querySelectorAll('[data-aib-market-field="country"] [data-aib-market-option]') || [])];
    countryOptionsByCode = new Map(countryOptions.map(option => [option.dataset.country, option]));
    optionsByField = new Map(marketFields.map(field => {
      const options = [...field.querySelectorAll('[data-aib-market-option]')];
      options.forEach(option => { option.aibSearchText = `${option.dataset.name} ${option.dataset.country} ${option.dataset.currency}`.toLocaleLowerCase(); });
      return [field, options];
    }));
  };
  // The full country list ships inside an inert <template> so its ~1,500 nodes are only built when the selector is first opened.
  const hydrateMarketOptions = () => {
    const templates = marketForm?.querySelectorAll('template[data-aib-market-more]');
    if (!templates?.length) return;
    templates.forEach(template => template.replaceWith(template.content));
    indexMarketOptions();
  };
  indexMarketOptions();
  const setMarketFlag = (image, url, alt = '') => {
    if (!image || !url) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = url;
    image.alt = alt;
  };
  const isMarketDialogOpen = () => Boolean(marketDialog && !marketDialog.hidden);
  const transitionMs = el => {
    if (!el) return 0;
    const value = getComputedStyle(el).transitionDuration || '0s';
    return value.split(',').reduce((max, part) => Math.max(max, (parseFloat(part) || 0) * 1000), 0);
  };
  const maxTransitionMs = (...els) => els.reduce((max, el) => Math.max(max, transitionMs(el)), 0);
  const revealWithTransition = el => requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-open')));
  let marketDialogOpener;
  const positionMarketDialog = () => {
    const isMobileSheet = window.matchMedia('(max-width: 1149px)').matches;
    document.documentElement.classList.toggle('aib-market-sheet-open', isMarketDialogOpen() && isMobileSheet);
    if (!marketDialog || !marketDialogOpener || isMobileSheet) return;
    const openerRect = marketDialogOpener.getBoundingClientRect();
    const panelWidth = marketDialog.offsetWidth;
    const left = Math.max(14, Math.min(window.innerWidth - panelWidth - 14, openerRect.left + (openerRect.width - panelWidth) / 2));
    marketDialog.style.left = `${Math.round(left)}px`;
    marketDialog.style.right = 'auto';
    marketDialog.style.top = `${Math.round(openerRect.bottom + 10)}px`;
  };
  const closeMarketDialog = () => {
    if (!marketDialog || marketDialog.hidden) return;
    document.querySelectorAll('[data-aib-market-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    marketDialog.classList.remove('is-open');
    closeMarketOptions();
    const delay = maxTransitionMs(marketDialog, marketDialog.querySelector('.aib-market-dialog__backdrop'), marketDialog.querySelector('.aib-market-dialog__panel'));
    const finish = () => {
      marketDialog.hidden = true;
      document.documentElement.classList.remove('aib-market-sheet-open');
      if (marketStatus) marketStatus.textContent = '';
    };
    if (delay > 0) setTimeout(finish, delay); else finish();
  };
  const closeMarketOptions = exception => marketFields.forEach(field => {
    if (field === exception) return;
    const options = field.querySelector('[data-aib-market-options]');
    if (options.hidden) return;
    options.classList.remove('is-open');
    field.querySelector('[data-aib-market-toggle]').setAttribute('aria-expanded', 'false');
    const delay = transitionMs(options);
    const finish = () => { options.hidden = true; };
    if (delay > 0) setTimeout(finish, delay); else finish();
  });
  const getCountryOption = countryCode => countryOptionsByCode.get(countryCode);
  const syncMarketSelection = countryCode => {
    const countryOption = getCountryOption(countryCode);
    if (!countryOption || !marketCountry) return;
    const currency = countryOption.dataset.currency;
    marketCountry.value = countryOption.dataset.country;
    const countryLabel = marketForm.querySelector('[data-aib-country-label]');
    const currencyLabel = marketForm.querySelector('[data-aib-currency-label]');
    const countryFlag = marketForm.querySelector('[data-aib-country-flag]');
    const currencyFlag = marketForm.querySelector('[data-aib-currency-flag]');
    countryLabel.textContent = countryOption.dataset.name;
    currencyLabel.textContent = currency;
    setMarketFlag(countryFlag, countryOption.dataset.flag, countryOption.dataset.name);
    setMarketFlag(currencyFlag, countryOption.dataset.flag, countryOption.dataset.name);
    marketFields.forEach(field => optionsByField.get(field).forEach(option => {
      const selected = field.dataset.aibMarketField === 'country' ? option.dataset.country === countryCode : option.dataset.currency === currency;
      option.setAttribute('aria-selected', selected ? 'true' : 'false');
    }));
  };
  document.querySelectorAll('[data-aib-market-open]').forEach(button => button.addEventListener('click', () => {
    // Paint the dialog first; build the country list right after so it isn't part of this tap's INP.
    requestAnimationFrame(() => setTimeout(hydrateMarketOptions, 0));
    const current = document.querySelector('[data-aib-market-value]')?.textContent.trim().split(' / ')[0];
    if (current) syncMarketSelection(current);
    if (!marketDialog) return;
    const willOpen = marketDialog.hidden;
    if (willOpen) {
      marketDialogOpener = button;
      marketDialog.hidden = false;
      positionMarketDialog();
      revealWithTransition(marketDialog);
    }
    else closeMarketDialog();
    document.querySelectorAll('[data-aib-market-open]').forEach(opener => opener.setAttribute('aria-expanded', willOpen ? 'true' : 'false'));
  }));
  marketDialog?.querySelector('[data-aib-market-dismiss]')?.addEventListener('click', closeMarketDialog);
  marketDialog?.querySelector('[data-aib-country-close]')?.addEventListener('click', () => closeMarketOptions());
  window.addEventListener('resize', debounce(positionMarketDialog, 80), { passive: true });
  marketFields.forEach(field => {
    const toggle = field.querySelector('[data-aib-market-toggle]');
    const options = field.querySelector('[data-aib-market-options]');
    field.addEventListener('click', event => {
      hydrateMarketOptions();
      const option = event.target.closest('[data-aib-market-option]');
      if (option) {
        syncMarketSelection(option.dataset.country);
        closeMarketOptions();
        return;
      }
      if (!event.target.closest('[data-aib-market-toggle]')) return;
      const willOpen = options.hidden;
      closeMarketOptions(field);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (willOpen) {
        options.hidden = false;
        revealWithTransition(options);
        setTimeout(() => options.querySelector('[data-aib-market-search]')?.focus(), 0);
      } else {
        options.classList.remove('is-open');
        const delay = transitionMs(options);
        const finish = () => { options.hidden = true; };
        if (delay > 0) setTimeout(finish, delay); else finish();
      }
    });
    field.querySelector('[data-aib-market-search]')?.addEventListener('input', debounce(event => {
      const query = event.target.value.trim().toLocaleLowerCase();
      optionsByField.get(field).forEach(option => {
        const hidden = !option.aibSearchText.includes(query);
        option.hidden = hidden;
        const item = option.closest('li');
        if (item) item.hidden = hidden;
      });
    }, 80));
  });
  document.addEventListener('click', event => {
    if (!isMarketDialogOpen()) return;
    if (!event.target.closest('[data-aib-market-field]')) closeMarketOptions();
    if (!event.target.closest('[data-aib-market-dialog], [data-aib-market-open]')) closeMarketDialog();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || !isMarketDialogOpen()) return;
    if (marketFields.some(field => !field.querySelector('[data-aib-market-options]').hidden)) closeMarketOptions();
    else closeMarketDialog();
  });
  marketForm?.addEventListener('submit', async event => {
    event.preventDefault();
    if (!marketCountry || !marketSave || marketSave.disabled) return;
    const selected = getCountryOption(marketCountry.value);
    if (!selected) return;
    const current = document.querySelector('[data-aib-market-value]')?.textContent.trim().split(' / ')[0];
    if (selected.dataset.country === current) { closeMarketDialog(); return; }
    marketSave.disabled = true;
    marketForm.setAttribute('aria-busy', 'true');
    marketStatus.textContent = marketForm.dataset.updatingText || '';
    try {
      const body = new FormData(marketForm);
      body.set('country_code', selected.dataset.country);
      body.set('return_to', `${window.location.pathname}${window.location.search}`);
      const response = await fetch(marketForm.action, { method: 'POST', body, credentials: 'same-origin', headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('Market update failed');
      const html = await response.text();
      const freshDocument = new DOMParser().parseFromString(html, 'text/html');
      const freshMain = freshDocument.querySelector('#MainContent');
      if (!freshMain) throw new Error('Updated storefront content is missing');
      const updateStorefront = () => {
        const currentMain = document.querySelector('#MainContent');
        const currentOutsideMoney = [...document.querySelectorAll('.hdt-money')].filter(node => !node.closest('#MainContent'));
        const freshOutsideMoney = [...freshDocument.querySelectorAll('.hdt-money')].filter(node => !node.closest('#MainContent'));
        currentOutsideMoney.forEach((node, index) => { if (freshOutsideMoney[index]) node.innerHTML = freshOutsideMoney[index].innerHTML; });
        currentMain?.replaceWith(freshMain);
        document.title = freshDocument.title;
        const freshCanonical = freshDocument.querySelector('link[rel="canonical"]')?.href;
        const currentCanonical = document.querySelector('link[rel="canonical"]');
        if (freshCanonical && currentCanonical) currentCanonical.href = freshCanonical;
        const optionName = selected.dataset.name;
        document.querySelectorAll('[data-aib-market-value]').forEach(value => { value.textContent = `${selected.dataset.country} / ${selected.dataset.currency}`; });
        document.querySelectorAll('.aib-market-selector__flag').forEach(flag => setMarketFlag(flag, selected.dataset.flag, optionName));
        const currentHeaderLinks = document.querySelectorAll('[data-aib-market-header] a');
        const freshHeaderLinks = freshDocument.querySelectorAll('[data-aib-market-header] a');
        currentHeaderLinks.forEach((link, index) => { if (freshHeaderLinks[index]) link.href = freshHeaderLinks[index].href; });
        const freshForm = freshDocument.querySelector('[data-aib-market-form]');
        if (freshForm) marketForm.action = freshForm.action;
        if (window.Shopify?.currency) window.Shopify.currency.active = selected.dataset.currency;
        const destination = new URL(response.url, window.location.href);
        if (destination.origin === window.location.origin) {
          history.replaceState(history.state, '', `${destination.pathname}${destination.search}${destination.hash}`);
          if (window.Shopify?.routes && freshForm) {
            const localizationPath = new URL(freshForm.action).pathname;
            window.Shopify.routes.root = localizationPath.replace(/localization\/?$/, '');
          }
        }
        freshMain.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      };
      updateStorefront();
      marketStatus.textContent = '';
      closeMarketDialog();
    } catch (_) {
      marketStatus.textContent = marketForm.dataset.errorText || '';
    } finally {
      marketSave.disabled = false;
      marketForm.removeAttribute('aria-busy');
    }
  });
  document.querySelectorAll('[data-aib-trust-strip]').forEach(strip => {
    const track = strip.querySelector('[data-aib-trust-track]');
    const previous = strip.querySelector('[data-aib-trust-previous]');
    const next = strip.querySelector('[data-aib-trust-next]');
    if (!track || !previous || !next) return;
    const updateTrustArrows = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
    };
    previous.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }));
    track.addEventListener('scroll', debounce(updateTrustArrows, 40), { passive: true });
    window.addEventListener('resize', debounce(updateTrustArrows, 80), { passive: true });
    updateTrustArrows();
  });
  const initializeProductCarousels = (root = document) => {
    const carousels = [];
    if (root.matches?.('[data-aib-product-carousel]')) carousels.push(root);
    carousels.push(...(root.querySelectorAll?.('[data-aib-product-carousel]') || []));
    carousels.forEach(carousel => {
      if (carousel.dataset.aibCarouselReady === 'true') return;
      const track = carousel.querySelector('[data-aib-carousel-track]');
      const previous = carousel.querySelector('[data-aib-carousel-previous]');
      const next = carousel.querySelector('[data-aib-carousel-next]');
      if (!track || !previous || !next) return;
      carousel.dataset.aibCarouselReady = 'true';
      const updateArrows = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = maxScroll <= 2 || track.scrollLeft >= maxScroll - 2;
      };
      const scrollPage = direction => track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
      previous.addEventListener('click', () => scrollPage(-1));
      next.addEventListener('click', () => scrollPage(1));
      track.addEventListener('scroll', debounce(updateArrows, 40), { passive: true });
      window.addEventListener('resize', debounce(updateArrows, 80), { passive: true });
      requestAnimationFrame(updateArrows);
    });
  };
  initializeProductCarousels();
  document.addEventListener('shopify:section:load', event => initializeProductCarousels(event.target));
  document.addEventListener('click', event => {
    const tab = event.target.closest('[data-aib-new-arrivals-tab]');
    if (!tab) return;
    const section = tab.closest('[data-aib-new-arrivals-tabs]');
    if (!section) return;
    const tabs = [...section.querySelectorAll('[data-aib-new-arrivals-tab]')];
    const panels = [...section.querySelectorAll('[data-aib-new-arrivals-panel]')];
    tabs.forEach(item => {
      const selected = item === tab;
      item.setAttribute('aria-selected', selected ? 'true' : 'false');
      item.tabIndex = selected ? 0 : -1;
    });
    panels.forEach(panel => {
      panel.hidden = panel.id !== tab.getAttribute('aria-controls');
    });
    const activePanel = panels.find(panel => panel.id === tab.getAttribute('aria-controls'));
    requestAnimationFrame(() => {
      initializeProductCarousels(activePanel || section);
      activePanel?.querySelector('[data-aib-carousel-track]')?.dispatchEvent(new Event('scroll'));
    });
  });
  let headerOffset;
  const syncHeaderOffset = () => {
    if (!marketHeader || !window.matchMedia('(min-width: 1150px)').matches) return;
    const offset = Math.max(0, Math.round(marketHeader.getBoundingClientRect().bottom));
    // Setting a custom property on <html> restyles the whole page, so only write when it changes.
    if (offset === headerOffset) return;
    headerOffset = offset;
    document.documentElement.style.setProperty('--aib-header-offset', `${offset}px`);
  };
  const closePriceFilter = (root = document) => {
    root.querySelectorAll('[data-aib-price-filter]').forEach(details => {
      details.open = false;
      details.setAttribute('aria-expanded', 'false');
    });
  };
  const restoreCustomFilterInputs = (root = document) => {
    const params = new URLSearchParams(window.location.search);
    const drawer = root.id === 'hdt-filter_form' ? root : root.querySelector?.('#hdt-filter_form');
    drawer?.querySelectorAll('input[type="checkbox"][name]').forEach(input => {
      input.checked = params.getAll(input.name).includes(input.value);
    });
  };
  let baseCustomFiltersPromise;
  const getBaseCustomFilters = () => {
    if (baseCustomFiltersPromise) return baseCustomFiltersPromise;
    const form = document.getElementById('hdt-facet-filters-form');
    const section = form?.closest('.shopify-section');
    const sectionId = section?.id?.replace('shopify-section-', '');
    if (!form || !sectionId) return Promise.resolve([]);
    const baseUrl = new URL(form.action, window.location.origin);
    baseUrl.search = '';
    baseUrl.searchParams.set('section_id', sectionId);
    baseCustomFiltersPromise = fetch(baseUrl, { headers: { Accept: 'text/html' } })
      .then(response => response.ok ? response.text() : Promise.reject(new Error('Unable to load base filters')))
      .then(html => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        return [...parsed.querySelectorAll('[data-aib-filter-group]')].map(group => group.closest('hdt-accordion')?.outerHTML).filter(Boolean);
      })
      .catch(() => []);
    return baseCustomFiltersPromise;
  };
  const stabilizeCustomFilterGroups = async () => {
    const markup = await getBaseCustomFilters();
    if (!markup.length) return;
    const form = document.getElementById('hdt-facet-filters-form');
    if (!form) return;
    const openGroups = new Set([...form.querySelectorAll('[data-aib-filter-group][open]')].map(group => group.dataset.aibFilterGroup));
    const currentWrappers = [...form.querySelectorAll('[data-aib-filter-group]')].map(group => group.closest('hdt-accordion')).filter(Boolean);
    const template = document.createElement('template');
    template.innerHTML = markup.join('');
    const stableWrappers = [...template.content.children];
    stableWrappers.forEach(wrapper => {
      const group = wrapper.querySelector('[data-aib-filter-group]');
      if (group && openGroups.has(group.dataset.aibFilterGroup)) {
        group.open = true;
        group.setAttribute('aria-expanded', 'true');
      }
    });
    if (currentWrappers.length) {
      currentWrappers[0].replaceWith(...stableWrappers);
      currentWrappers.slice(1).forEach(wrapper => wrapper.remove());
    } else {
      form.querySelector('hdt-accordion')?.before(...stableWrappers);
    }
    restoreCustomFilterInputs(document.getElementById('hdt-filter_form') || document);
  };
  const applyCustomProductFilters = (root = document) => {
    const params = new URLSearchParams(window.location.search);
    const selectedVendors = params.getAll('filter.p.vendor');
    const selectedSizes = params.getAll('filter.v.option.size');
    const selectedColors = params.getAll('filter.v.option.color');
    const selectedDiscounts = params.getAll('aib_discount');
    root.querySelectorAll('[data-aib-product-card]').forEach(card => {
      const sizes = (card.dataset.aibSizes || '').split('||').filter(Boolean);
      const colors = (card.dataset.aibColors || '').split('||').filter(Boolean);
      const discounts = (card.dataset.aibDiscounts || '').split(',').filter(Boolean);
      const vendorMatches = selectedVendors.length === 0 || selectedVendors.includes(card.dataset.aibVendor || '');
      const sizeMatches = selectedSizes.length === 0 || selectedSizes.some(value => sizes.includes(value));
      const colorMatches = selectedColors.length === 0 || selectedColors.some(value => colors.includes(value));
      const discountMatches = selectedDiscounts.length === 0 || selectedDiscounts.some(value => discounts.includes(value));
      card.hidden = !(vendorMatches && sizeMatches && colorMatches && discountMatches);
    });
  };
  const buildFilterUrl = form => {
    const url = new URL(form.action, window.location.origin);
    url.search = '';
    new FormData(form).forEach((value, key) => {
      if (key !== 'page' && String(value).trim() !== '') url.searchParams.append(key, value);
    });
    return url;
  };
  const closeMobileFilterDrawer = () => {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    document.getElementById('hdt-filter_form')?.parentElement?.close?.();
  };
  let filterRequest;
  const updateFilterResults = async (url, updateHistory = true) => {
    const currentResults = document.querySelector('.hdt-main-collection-content .hdt-shop-content');
    if (!currentResults) {
      if (updateHistory) history.pushState({ aibFilters: true }, '', url);
      applyCustomProductFilters();
      closeMobileFilterDrawer();
      return;
    }
    filterRequest?.abort();
    filterRequest = new AbortController();
    currentResults.classList.add('aib-filter-loading');
    currentResults.setAttribute('aria-busy', 'true');
    const section = currentResults.closest('.shopify-section');
    const sectionId = section?.id?.replace('shopify-section-', '');
    const requestUrl = new URL(url);
    if (sectionId) requestUrl.searchParams.set('section_id', sectionId);
    try {
      const response = await fetch(requestUrl, { signal: filterRequest.signal, headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Unable to update filters');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextResults = parsed.querySelector('.hdt-main-collection-content .hdt-shop-content');
      if (!nextResults) throw new Error('Product results missing');
      if (updateHistory) history.pushState({ aibFilters: true }, '', url);
      const currentMain = currentResults.closest('[main-content]');
      const nextMain = nextResults.closest('[main-content]');
      const currentActiveFilters = currentMain?.querySelector('.hdt-active-filters');
      const nextActiveFilters = nextMain?.querySelector('.hdt-active-filters');
      if (currentActiveFilters && nextActiveFilters) {
        currentActiveFilters.replaceWith(document.importNode(nextActiveFilters, true));
      } else if (currentActiveFilters && !nextActiveFilters) {
        currentActiveFilters.remove();
      } else if (!currentActiveFilters && nextActiveFilters) {
        currentMain?.querySelector('.hdt-row-flex')?.before(document.importNode(nextActiveFilters, true));
      }
      const importedResults = document.importNode(nextResults, true);
      importedResults.removeAttribute('aria-busy');
      currentResults.replaceWith(importedResults);
      applyCustomProductFilters(importedResults);
      importedResults.dispatchEvent(new CustomEvent('products:update', { bubbles: true }));
      await stabilizeCustomFilterGroups();
      closeMobileFilterDrawer();
    } catch (error) {
      if (error.name !== 'AbortError') {
        currentResults.classList.remove('aib-filter-loading');
        currentResults.removeAttribute('aria-busy');
        if (updateHistory) history.pushState({ aibFilters: true }, '', url);
        applyCustomProductFilters(currentResults);
        closeMobileFilterDrawer();
      }
    }
  };
  const autoUpdatePriceFilter = debounce(() => {
    const form = document.getElementById('hdt-facet-filters-form');
    if (form) updateFilterResults(buildFilterUrl(form));
  }, 450);
  closePriceFilter();
  restoreCustomFilterInputs();
  if ([...new URLSearchParams(window.location.search).keys()].some(key => key.startsWith('filter.') || key.startsWith('aib_'))) {
    stabilizeCustomFilterGroups();
  }
  applyCustomProductFilters();
  syncHeaderOffset();
  window.addEventListener('resize', debounce(syncHeaderOffset, 80), { passive: true });
  window.addEventListener('scroll', debounce(syncHeaderOffset, 20), { passive: true });
  document.addEventListener('click', event => {
    const filterDrawerTrigger = event.target.closest('[aria-controls="hdt-filter_form"]');
    if (filterDrawerTrigger && !filterDrawerTrigger.closest('#hdt-filter_form')) {
      requestAnimationFrame(() => {
        const drawer = document.getElementById('hdt-filter_form') || document;
        closePriceFilter(drawer);
        restoreCustomFilterInputs(drawer);
      });
    }
    const clearFilters = event.target.closest('[data-aib-filter-clear]');
    if (clearFilters) {
      event.preventDefault();
      const drawer = document.getElementById('hdt-filter_form');
      drawer?.querySelectorAll('input[type="checkbox"][name]').forEach(input => { input.checked = false; });
      drawer?.querySelectorAll('.hdt-filter-group__input-price input[type="number"]').forEach(input => { input.value = ''; });
      drawer?.querySelectorAll('.hdt-filter-group__range-price input[type="range"]').forEach((input, index, inputs) => {
        input.value = index === 0 ? input.min : input.max;
      });
      updateFilterResults(new URL(clearFilters.href, window.location.origin));
      return;
    }
    const buyNow = event.target.closest('[data-aib-buy-now]');
    if (!buyNow) return;
    const form = buyNow.closest('form');
    if (!form || !form.reportValidity()) return;
    event.preventDefault();
    buyNow.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(response => { if (!response.ok) throw new Error('Unable to add item'); window.location.assign('/checkout'); })
      .catch(() => { buyNow.disabled = false; form.requestSubmit(); });
  });
  document.addEventListener('change', event => {
    if (!event.target.closest('#hdt-filter_form') || !event.target.matches('input[type="checkbox"]')) return;
    // A render-on-change form already submitted (handled by the submit listener below); don't fetch twice.
    if (event.target.closest('hdt-facet-filters-form[render-on-change]') && !event.target.hasAttribute('disable-change')) return;
    const form = document.getElementById('hdt-facet-filters-form');
    if (form) updateFilterResults(buildFilterUrl(form));
  });
  document.addEventListener('input', event => {
    if (!event.target.closest('#hdt-filter_form') || !event.target.matches('input[type="range"], input[type="number"]')) return;
    autoUpdatePriceFilter();
  });
  document.addEventListener('click', event => {
    const activeFilterLink = event.target.closest('.hdt-active-filters a[href]');
    if (!activeFilterLink) return;
    event.preventDefault();
    event.stopPropagation();
    updateFilterResults(new URL(activeFilterLink.href, window.location.origin));
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.id !== 'hdt-facet-filters-form') return;
    event.preventDefault();
    event.stopPropagation();
    updateFilterResults(buildFilterUrl(event.target));
  }, true);
  window.addEventListener('popstate', () => {
    restoreCustomFilterInputs();
    updateFilterResults(new URL(window.location.href), false);
  });
  document.addEventListener('products:update', event => {
    applyCustomProductFilters(event.target);
    initializeProductCarousels(event.target);
  });
})();
